import styled from 'styled-components'
import FormError from '../FormError'

const FormErrorField = styled(FormError)`
  display: block;
  text-align: center;
  margin: 20px 0;
`

export default FormErrorField
